import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/** Blocks a route unless a valid (non-expired) session exists. */
export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.ensureSession()) return true;

  return router.createUrlTree(['/auth/login'], {
    queryParams: { returnUrl: state.url },
  });
};

/**
 * Blocks a portal section unless the user's role matches `data.role`.
 * Also enforces authentication. A logged-in user hitting the wrong
 * portal is redirected to their own.
 */
export const roleGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.ensureSession()) {
    return router.createUrlTree(['/auth/login'], {
      queryParams: { returnUrl: state.url },
    });
  }

  const required = route.data?.['role'] as string | undefined;
  const userRole = auth.currentUser()?.role;

  if (!required || userRole === required) return true;

  // Authenticated but wrong portal — send them to theirs
  return router.createUrlTree([`/portal/${userRole}`]);
};

/** Keeps authenticated users away from auth pages (login/register/landing). */
export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.ensureSession()) return true;

  const role = auth.currentUser()?.role ?? 'citizen';
  return router.createUrlTree([`/portal/${role}`]);
};
